import http from '@/utils/http';

const URL_BASE = '/contrato-originacao';

export function buscarPlantasFabrisPorFiltro({ filtro, pageable }) {
    const { page, size, sort, order } = pageable;

    return http.post({
        url: `/plantas-fabris/filtro?page=${page}&size=${size}&sort=${sort},${order}`,
        data: filtro,
        lockScreen: true,
        notify: {
            status: [500]
        }
    });
}

export function buscarMaterialPorTipo(id = 1) {
    return http.get({
        url: `${URL_BASE}/material/buscar/tipo?id=${id}`,
        lockScreen: false
    });
}

export function buscarPlantaFabrilPorId(id) {
    return http.get({
        url: `/plantas-fabris/${id}`,
        lockScreen: true,
        notify: {
            status: [500]
        }
    });
}

export function cadastrarPlantaFabril(data) {
    return http.post({
        url: `/plantas-fabris`,
        data,
        lockScreen: true,
        notify: {
            status: [500]
        }
    });
}

export function atualizarPlantaFabril(id, data) {
    return http.put({
        url: `/plantas-fabris/${id}`,
        data,
        lockScreen: true,
        notify: {
            status: [500]
        }
    });
}

export function deletarPlantaFabril(id) {
    return http.delete({
        url: `/plantas-fabris/${id}`,
        lockScreen: true,
        notify: {
            status: [500]
        }
    });
}

export default {
    buscarPlantasFabrisPorFiltro,
    buscarMaterialPorTipo,
    buscarPlantaFabrilPorId,
    cadastrarPlantaFabril,
    atualizarPlantaFabril,
    deletarPlantaFabril
};
